import React from 'react';
import _get from 'lodash/get';

function getStyles(data) {
  const error = _get(data, 'error', false);

  return {
    container: (provided, state) => ({
      ...provided,
      // boxShadow: error
      //   ? "0 0 4px 0 rgba(255, 121, 121, 0.3)"
      //   : state.isDisabled
      //   ? "none"
      //   : state.isFocused
      //   ? "0 0 4px 0 rgba(60, 49, 255, 0.2)"
      //   : "0 0 4px 0 rgba(0, 0, 0, 0.1)",
      backgroundColor: state.isDisabled ? '#f7f7f7' : '#ffffff',
      borderRadius: '4px',
    }),
    control: (provided, state) => ({
      ...provided,
      boxShadow: error
        ? 'none'
        : state.isDisabled
          ? 'none'
          : state.isFocused
            ? '0 0 4px 0 #f2c6ab'
            : '0 0 4px 0 rgba(12, 19, 26, 0.18)',
      border: error
        ? '1px solid #da4d4db3'
        : state.isDisabled
          ? '1px solid #e4f0fe'
          : 'none',
      minHeight: '44px',
      borderRadius: state.isFocused ? '4px 4px 0 0' : '4px',
      backgroundColor: state.isDisabled ? '#fafcff' : '#ffffff',
      cursor: state.isDisabled ? 'not-allowed' : 'unset',
      '&:hover': {
        border: error ? '1px solid rgba(255, 121, 121, 0.5)' : 'none',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#0c131a',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transition: 'all 150ms',
      transform: state.isFocused ? 'rotateX(180deg)' : 'rotateX(0)',
    }),
    group: (provided) => {
      return {
        ...provided,
        padding: '0',
        // '&:nth-child(2n)': {
        //   backgroundColor: '#fff',
        //   '.uiKit__select__box__group-heading': {
        //     backgroundColor: '#fff'
        //   }
        // },
        // '&:nth-child(2n+1)': {
        //   backgroundColor: '#fafaff',
        //   '.uiKit__select__box__group-heading': {
        //     backgroundColor: '#fafaff'
        //   }
        // }
      };
    },
    groupHeading: (provided) => {
      return {
        ...provided,
        // borderBottom: "1px solid #eee",
        backgroundColor: '#fff',
        padding: '8px 12px',
        margin: '0',
        position: 'sticky',
        top: '0',
      };
    },
    indicatorsContainer: (provided) => ({ ...provided, cursor: 'pointer' }),
    indicatorSeparator: () => ({ display: 'none' }),
    placeholder: (provided) => ({ ...provided, color: '#a6afb8' }),
    menu: (provided) => ({
      ...provided,
      margin: '0',
      boxShadow: '0 2px 4px 0 #f2c6ab',
      backgroundColor: '#ffffff',
      borderRadius: '0 0 4px 4px',
      borderTop: error ? 'none' : '1px solid #f2c6ab',
      zIndex: '100000',
    }),
    menuList: (provided) => ({
      ...provided,
      borderRadius: '0 0 4px 4px',
      padding: '0',
      position: 'relative',
    }),
    option: (provided, state) => {
      return {
        ...provided,
        backgroundColor: state.isFocused ? '#fbede5' : 'transparent',
        color: state.isSelected ? '#0c131a' : '#516f90',
        fontWeight: state.isSelected ? '500' : '400',
        cursor: 'pointer',
        '&:active': {
          backgroundColor: '#f2c6ab',
        },
        '&:focus-visible': {
          outlineColor: '#f2c6ab',
        },
      };
    },
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#fbede5',
      borderRadius: '4px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#607180',
      transform: 'translateY(-1px)',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      transform: 'translateY(1px)',
      color: '#607180',
      '&:hover': {
        backgroundColor: 'transparent',
        color: '#607180',
      },
    }),
    noOptionsMessage: () => ({ display: 'none' }),
  };
}

//--------------------------------------------------------------------------

const formatGroupLabel = (ifGrouped) => {
  return !ifGrouped
    ? null
    : (data) => (
        <div>
          <span
            style={{
              color: '#a6afb8',
              fontSize: '12px',
              fontWeight: '800',
            }}
          >
            {data.label}
          </span>
          <div
            style={{
              marginTop: '10px',
              boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.05)',
              borderTop: '1px solid #eeeeff',
            }}
          ></div>
        </div>
      );
};

//--------------------------------------------------------------------------

export { getStyles, formatGroupLabel };
